import React, { useEffect, useState } from "react";
import fnc from "../mymod/commFunction";
import fncSql from "../mymod/commFunctionSql";
import { useNavigate } from "react-router-dom";
import './Assess_etc_checkList_nm.scss';
import { useDispatch, useSelector } from "react-redux";
import * as S from '../scss/theme';
import  HongButton from '../comm/HongButton';
import imgReport from '../images/svg/report.svg';
import imgCheckList from '../images/svg/checklist.svg';
import imgDelete from '../images/svg/delete.svg';
import HeaderTitle from "../comm/HeaderTitle";
import Assess_etc_checkList_result from "./Assess_etc_checkList_result";
import { setSelectedTestCode } from "../reduxToolkit/reduxIgong";

const Assess_etc_checkList_nm = () => {
    const {stCode, userName, userKind2} = useSelector((state) => state.reduxIgong.userInfo);
    const selectedUserInfo = useSelector((state) => state.reduxIgong.selectedUserInfo);
    const selectedTestCode = useSelector((state) => state.reduxIgong.selectedTestCode);
    const selectedStCode = useSelector((state) => state.reduxIgong.selectedStCode);
    

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isRefresh, setIsRefresh] = useState(false);

    const [selectedSno, setSelectedSno] = useState(null);
    const [isModal_result, setIsModal_result] = useState(false);

    const [list, setList] = useState([]);
    const [title, setTitle] = useState('');
    const [testCode, setTestCode] = useState(null);


    useEffect(() => {
// selectedUserInfo.stCode
        const stCode = selectedStCode;
        fncSelect_list(selectedTestCode, stCode);
        setTitle(`${selectedUserInfo.userName}의 학업역량 진단 리스트`);
        alert(selectedTestCode)
    }, [isRefresh]);
    
  
  function fncSelect_list(pTestCode, stCode) {
    
    fnc.sendAxios('/igonAssess_etcRoutes/select/etc_testNm', { pTestCode, stCode }, (res) => {
      if (res && Array.isArray(res)) { 
        const newList = getRecords(res);
        setList(newList);
      } else {
        alert('검색에 실패했습니다.');
      }
    });
  }

  
  function getRecords(res) {
    let records = [];
    for (let i = 0; i < res.length; i++) { 
        const sno = res[i]["sno"];  
        const testDate = res[i]["testDate"];
        const stCode = res[i]["stCode"];
        const userName = res[i]["userName"];
        const testCode = res[i]["testCode"];
        let sDate = res[i]["sDate"];
        sDate = fnc.formatDate2(sDate);    
        records.push({ sno, testDate, stCode, userName, testCode, sDate });
    }
    return records;
  }

    
  
  function onClickTr( item, index) {

  }



  function onClickCheckList(item) {
    fncSql.getUserInfo(dispatch, item.stCode, () => {
      setTestCode(item.testCode);
      setIsModal_result(true);
    });
  }

  function onClickDelete(item) {
    const testCode = item.testCode;
    const stCode = item.stCode;
    const testDate = item.testDate;
   
    const rtn = window.confirm(`${testDate}일자 진단을 정말로 삭제하시겠습니까?`);
    if (!rtn) return;

    fncDelete_etc_marking(testCode, stCode);

      
    function fncDelete_etc_marking(testCode, stCode) {
      fnc.sendAxios('/igonAssess_etcRoutes/delete/etc_marking', { testCode, stCode }, (res) => {
        if (res) { 
            if(res.success) {
              setIsRefresh(!isRefresh);
              alert('완료되었습니다.');  
            }
        } else {
          alert('검색에 실패했습니다.');
        }
      });
    }

  }
  

  
  

    //==================================================================================
    return (
        <S.Section>
        <HeaderTitle  title={title} direction={1} onBackClick={() => navigate(-1)} />
           
        <div className="Assess_etc_checkList_nm">
        <section className='sec-main'>
            <title></title>
                    <table className="table-hong table-main">
                    <thead>
                        <tr>
                        <th>No</th>
                        <th>진단일자</th>
                        <th>이름</th>
                        <th>마킹결과</th>
                        <th>삭제</th>
                        </tr>
                    </thead>

                    <tbody>
                        {list && list.map((item, index) => (
        
                            <tr key={index} onClick={() => onClickTr(item, index)}
                                className={selectedSno === item.sno ? 'selected' : ''}>  
                                <td>{index+1}</td>
                                <td>{item.testDate}</td>
                                <td>{item.userName}</td>

                                <td>
                                    <HongButton className="btnReport"  
                                        onClick={() => onClickCheckList(item)}
                                        startIcon={<img src={imgCheckList} alt="CheckList" />}
                                    >
                                    </HongButton>
                                </td>
                                <td>
                                    <HongButton className="btnReport"  
                                        onClick={() => onClickDelete(item)}
                                        startIcon={<img src={imgDelete} alt="CheckList" />}
                                    >
                                    </HongButton>
                                </td>

                            </tr>
                        ))}
                    
                        </tbody>

                    </table>

                </section> 

            
                </div>

                {isModal_result && (
                    <S.Modal_pc>
                        <HeaderTitle  title={title} direction={1} onBackClick={() => setIsModal_result(false)} />
                        <section className="">
                                <Assess_etc_checkList_result testCode={testCode} stCode={selectedStCode}/>
                        </section>              
                    </S.Modal_pc>
                 )}

        </S.Section>
    );
};

export default Assess_etc_checkList_nm;
